import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  AggregationInterval, ArgumentAxis, Label, ZoomAndPan,
  TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';

import PieChart, { Legend as PCLegend, Series as PCSeries,
  Tooltip as PCTooltip, Label as PCLabel,
  Connector, } from 'devextreme-react/pie-chart';
import { SelectBox } from 'devextreme-react/select-box';
import { groupBy, calcWeightData, Array_Average, Quartile } from '../../utils/miscUtil';
import { AvgTable } from '../'

export default function HSEWater(props) {
  const [recycleData, setRecycleData] = useState();
  const [waterData, setWaterData] = useState();
  const [qData, setQData] = useState([]);
  const [waterCompaniesList, setWaterCompaniesList] = useState([]);
  const [recycleCompaniesList, setRecycleCompaniesList] = useState([]);
  const [reportingCompanies, setReportingCompanies] = useState([]);
  const [weightData, setWeightData] = useState({});
  const [weight, setWeight] = useState(null);
  const [avgDataR, setAvgDataR] = useState(null);
  const [avgDataW, setAvgDataW] = useState(null);

  useEffect(() => {
    setWeightData(calcWeightData(props.data, props.year));
    setWeight("Oil & Gas Weighted");
  }, [props.data, props.year]);

  const customizeTooltip = useCallback((pointInfo) => {
    var cn = ""
    if (pointInfo.seriesName.includes("Series")) {
      cn = "Company "+pointInfo.seriesName.split(" ")[1]
    } else {
      cn = pointInfo.seriesName
    }
    const y = pointInfo.argument.toLocaleString('default', {year: 'numeric'});
    var txt = ''
    txt = `<div><div class="tooltip-header">${y}</div><div class="tooltip-body">`
    txt = txt+`<div>${cn}: ${pointInfo.value}</div>`
    txt=txt+`</div></div>`
    return {
      html: txt,
    }
  }, []);

  const customizeTooltip2 = useCallback((pointInfo) => {
    const y = pointInfo.argument.toLocaleString('default', { year: 'numeric'});
    var txt = ''
    txt = `<div><div class="tooltip-header">${y} - ${pointInfo.value} Companies</div></div>`
    return {
      html: txt,
    }
  }, []);

  const onWeightChanged = useCallback((e) => {
    setWeight(e.value);
  }, [setWeight])


  useEffect(() => {
    if (!weight) {
      return
    }
    var repfd = {}
    var fd = props.data.filter((e) => {return e["Identifier"] === "141"});
    for (var i=0; i<fd.length; i++) {
      fd[i]['company_'+fd[i].company_id] = parseFloat(fd[i].value?.replaceAll(",","")) || null;
      fd[i]['date'] = new Date(fd[i]['year'], 0)
    }

    var fd1 = groupBy(fd,"company_id");
    for (const [key] of Object.entries(fd1)) {
      var val = 0;
      var cn = null;
      for (i=0; i<fd1[key].length; i++){
        if (fd1[key][i]["year"] === props.year) {
          val = fd1[key][i]["value"];
          cn = fd1[key][i]["company_name"]
        }
      }
      fd1[key] = {value: parseFloat(val?.replaceAll(",","")) || null, company_name: cn};
    }

    fd1 = Object.keys(fd1).map((key) => ({company_id:key, value:fd1[key].value, company_name:fd1[key].company_name}));
    fd1 = fd1.filter((it) => weight.includes(weightData[it["company_id"]]))
    fd1 = fd1.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
    setWaterCompaniesList(fd1);

    fd1 = groupBy(fd,"year");
    for (const [key] of Object.entries(fd1)) {
      var vals = [];
      var v = 0;
      for (i=0; i<fd1[key].length; i++){
        v = parseFloat(fd1[key][i]["value"]?.replaceAll(",",""));
        if (!isNaN(v)) {
          vals.push(v)
          if (!repfd[key]) {
            repfd[key]=[]
          }
          if ((!(repfd[key].includes(fd1[key][i]['company_id']))) && (weight.includes(weightData[fd1[key][i]["company_id"]]))) {
            repfd[key].push(fd1[key][i]['company_id']);
          }
        }
      }

      fd1[key] = {avg: Array_Average(vals), q25: Quartile(vals, 0.25), q50: Quartile(vals, 0.50), q75: Quartile(vals, 0.75)};
    }
    fd1 = Object.keys(fd1).map((key) => ({date: new Date(key, 0), ...fd1[key]}));
    setAvgDataW(fd1);
    fd.push(...fd1)
    setWaterData(fd);

    fd = props.data.filter((e) => {return e["Identifier"] === "142"});
    for (i=0; i<fd.length; i++) {
      fd[i]['company_'+fd[i].company_id] = parseFloat(fd[i].value?.replaceAll(",","")) || null;
      fd[i]['date'] = new Date(fd[i]['year'], 0)
    }
    fd1 = groupBy(fd,"company_id");
    for (const [key] of Object.entries(fd1)) {
      val = 0;
      cn = null;
      for (i=0; i<fd1[key].length; i++){
        if (fd1[key][i]["year"] === props.year) {
          val = fd1[key][i]["value"];
          cn = fd1[key][i]["company_name"]
        }
      }
      fd1[key] = {value: parseFloat(val?.replaceAll(",","")) || null, company_name: cn};
    }

    fd1 = Object.keys(fd1).map((key) => ({company_id:key, value:fd1[key].value, company_name:fd1[key].company_name}));
    fd1 = fd1.filter((it) => weight.includes(weightData[it["company_id"]]))
    fd1 = fd1.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
    setRecycleCompaniesList(fd1);

    fd1 = groupBy(fd,"year");
    for (const [key] of Object.entries(fd1)) {
      vals = [];
      v = 0;
      for (i=0; i<fd1[key].length; i++){
        v = parseFloat(fd1[key][i]["value"]?.replaceAll(",",""));
        if (!isNaN(v)) {
          vals.push(v)
          if (!repfd[key]) {
            repfd[key]=[]
          }
          if ((!(repfd[key].includes(fd1[key][i]['company_id']))) && (weight.includes(weightData[fd1[key][i]["company_id"]]))) {
            repfd[key].push(fd1[key][i]['company_id']);
          }
        }
      }

      fd1[key] = {avg: Array_Average(vals), q25: Quartile(vals, 0.25), q50: Quartile(vals, 0.50), q75: Quartile(vals, 0.75)};
    }
    fd1 = Object.keys(fd1).map((key) => ({date: new Date(key, 0), ...fd1[key]}));
    setAvgDataR(fd1);
    fd.push(...fd1)
    setRecycleData(fd);

    fd = props.data.filter((e) => {return e["Identifier"] === "71" && e["year"] === props.year});
    fd = fd.filter((it) => weight.includes(weightData[it["company_id"]]))
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length}));
    setQData(fd);

    repfd = Object.keys(repfd).map((key) => ({date: new Date(key, 0) , count: repfd[key].length}));
    setReportingCompanies(repfd);

  }, [props.data, props.year, weight, weightData]);


  return (
    <>
    <div className="d-flex flex-row">
      <div className="d-flex flex-column me-4" style={{width:"30%"}}>
        <SelectBox
            dataSource={["Gas Weighted", "Oil Weighted", "Oil & Gas Weighted"]}
            value={weight}
            showDropDownButton={true}
            activeStateEnabled={true}
            onValueChanged={onWeightChanged}
            label={"Gas/Oil Weighted"}
            labelMode="floating"
            placeholder={"Gas/Oil Weighted"}
            noDataText={"Select a metric first"}
        >
        </SelectBox>
        <div className="mb-2"/>
        <Chart
          id="chart"
          dataSource={reportingCompanies}
          title={"Reporting Companies"}
          rotated={true}
          height="230px"
        >
          <ArgumentAxis aggregatedPointsPosition="crossTicks">
            <AggregationInterval years={1} />
            <TickInterval years={1} />
          </ArgumentAxis>
          <CommonSeriesSettings
            argumentField="date"
          >
          </CommonSeriesSettings>
          <Series
            type="bar"
            valueField={"count"}
            color="rgba(0, 162, 200, 0.8)"
          >
            <Label visible={true}/>

          </Series>

          <ValueAxis showZero={true} allowDecimal={false} tickInterval={5}>
          </ValueAxis>
          <Legend visible={false} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip2}
          />
        </Chart>

      </div>
      <div className="d-flex flex-column me-4" style={{width:"70%"}}>
        <PieChart
          id="pie"
          type="doughnut"
          title={"Does your company use a tool to determine the potential for water stressed areas in your portfolio? - "+props.year}
          palette={["rgba(20, 77, 109, 0.8)", "rgba(236, 80, 32, 0.8)", "rgba(92, 194, 215, 0.8)", "rgba(0, 162, 200, 0.8)"]}
          dataSource={qData}
          height="230px"
        >
          <PCSeries argumentField="name">
            <PCLabel visible={true}>
              <Connector visible={true} />
            </PCLabel>
          </PCSeries>
          <PCLegend margin={0} horizontalAlignment="right" verticalAlignment="top" />
          <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
          </PCTooltip>
        </PieChart>
      </div>
    </div>
    <div className="d-flex flex-row justify-content-between">
      <div className="d-flex flex-column" style={{width:"45%"}}>
        <Chart
          id="chart"
          dataSource={waterData}
          title={"Fresh Water Intensity"}
          height="50vh"
        >
          <ArgumentAxis aggregatedPointsPosition="crossTicks">
            <AggregationInterval years={1} />
            <TickInterval years={1} />
          </ArgumentAxis>
          <CommonSeriesSettings
            argumentField="date"
          >
          </CommonSeriesSettings>
          {waterCompaniesList.map((e) => (<Series
            type="bar"
            key={e.company_id}
            valueField={"company_"+e.company_id}
            showInLegend={false}
            name={e.company_name}
            color={e.company_name?"rgba(0, 162, 200, 0.8)":"rgba(236, 80, 32, 0.5)"}
            ignoreEmptyPoints={true}
          />))}
          <Series
            type="line"
            valueField="avg"
            name="Average"
            color="rgba(20, 77, 109, 1)"
            dashStyle="solid"
          />
          <Series
            type="line"
            valueField="q25"
            name="1st Quartile"
            color="rgba(20, 77, 109, 0.25)"
            dashStyle="dot"
          />
          <Series
            type="line"
            valueField="q50"
            name="2nd Quartile"
            color="rgba(20, 77, 109, 0.5)"
            dashStyle="dash"
          />
          <Series
            type="line"
            valueField="q75"
            name="3rd Quartile"
            color="rgba(20, 77, 109, 0.75)"
            dashStyle="longDash"
          />
          <ValueAxis showZero={false} />

          <Legend
            verticalAlignment="bottom"
            horizontalAlignment="center"
            itemTextPosition="bottom"
          />
          <ZoomAndPan
            valueAxis="both"
            argumentAxis="both"
            dragToZoom={true}
            allowMouseWheel={true}
            panKey="shift"
          />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
          />
        </Chart>
        <AvgTable data={avgDataW}/>
      </div>
      <div className="d-flex flex-column" style={{width:"45%"}}>
        <Chart
          id="chart"
          dataSource={recycleData}
          title={"Water Recycle Rate"}
          height="50vh"
        >
          <ArgumentAxis aggregatedPointsPosition="crossTicks">
            <AggregationInterval years={1} />
            <TickInterval years={1} />
          </ArgumentAxis>
          <CommonSeriesSettings
            argumentField="date"
          >
          </CommonSeriesSettings>
          {recycleCompaniesList.map((e) => (<Series
            type="bar"
            key={e.company_id}
            valueField={"company_"+e.company_id}
            showInLegend={false}
            name={e.company_name}
            color={e.company_name?"rgba(0, 162, 200, 0.8)":"rgba(236, 80, 32, 0.5)"}
            ignoreEmptyPoints={true}
          />))}
          <Series
            type="line"
            valueField="avg"
            name="Average"
            color="rgba(20, 77, 109, 1)"
            dashStyle="solid"
          />
          <Series
            type="line"
            valueField="q25"
            name="1st Quartile"
            color="rgba(20, 77, 109, 0.25)"
            dashStyle="dot"
          />
          <Series
            type="line"
            valueField="q50"
            name="2nd Quartile"
            color="rgba(20, 77, 109, 0.5)"
            dashStyle="dash"
          />
          <Series
            type="line"
            valueField="q75"
            name="3rd Quartile"
            color="rgba(20, 77, 109, 0.75)"
            dashStyle="longDash"
          />
          <ValueAxis showZero={false} />

          <Legend
            verticalAlignment="bottom"
            horizontalAlignment="center"
            itemTextPosition="bottom"
          />
          <ZoomAndPan
            valueAxis="both"
            argumentAxis="both"
            dragToZoom={true}
            allowMouseWheel={true}
            panKey="shift"
          />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
          />
        </Chart>
        <AvgTable data={avgDataR}/>
      </div>
    </div>
    </>
  );
}
